<acabim-datatable
    #dataTable
    [dataSources]="dataSources"
    hasDetailView="true"
    (showDetail)="toggleStatus(true)"></acabim-datatable>
<div class="cas-action-buttons">
    <button class="cas-button-action" (click)="toggleStatus(true)">Add</button>
</div>

<ng-template [ngIf]="showAddModal">
    <acabim-modal [display]="true" fixHeight="75vh" (status)="toggleStatus($event)" [title]="modalTitle" >
        <acabim-admin-financial-details
            [detailData]="dataSources[0].detailData"
            [classId]="classId"
            [classes]="classes"
            (close)="closeModal($event)"></acabim-admin-financial-details>
    </acabim-modal>
</ng-template>
<p-toast position="center"></p-toast>
